import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { ChartExportMenu } from '@/features/chart-export';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface EChartsWrapperProps {
  option: EChartsOption;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const EXPORT_POSITION_CLASSES = {
  'top-left': 'absolute top-2 left-2 z-10',
  'top-right': 'absolute top-2 right-2 z-10',
  'bottom-left': 'absolute bottom-2 left-2 z-10',
  'bottom-right': 'absolute bottom-2 right-2 z-10'
} as const;

export const EChartsWrapper: React.FC<EChartsWrapperProps> = ({
  option,
  height = 400,
  className = '',
  loading = false,
  showExport = false,
  exportOptions,
  exportPosition = 'top-right'
}) => {
  const chartRef = useRef<ReactECharts>(null);

  return (
    <div className={`relative w-full ${className}`}>
      {showExport && (
        <div className={EXPORT_POSITION_CLASSES[exportPosition]}>
          <ChartExportMenu
            chartRef={chartRef}
            chartOption={option as Record<string, unknown>}
            exportOptions={exportOptions}
            disabled={loading}
          />
        </div>
      )}
      <ReactECharts
        ref={chartRef}
        option={option}
        style={{ height }}
        showLoading={loading}
        theme="light"
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};
